<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkmessage_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/message/parkmessage';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        menuWidth: 80,
        refreshBtn:false,
        column: [
          {
            label: '车场',
            prop: 'parkingLotId',
            width: 120,
            type: 'select',
            search: true,
            searchSpan: 5,
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
          },
          {
            label: '状态码',
            prop: 'code',
            width: 70,
          },
          {
            label: '应答消息',
            prop: 'responseMessage',
            width: 100,
            overHidden: true,
          },
          {
            label: '消息名称',
            prop: 'serviceName',
            width: 200,
          },
          {
            label: '车场编码',
            prop: 'parkingLotCode',
            width: 120,
            hide: true,
          },
          {
            label: '备注信息',
            prop: 'remark',
            overHidden: true,
          },
          {
            label: '同步时间',
            prop: 'createTime',
            width: 140,
          },
          {
            label: '消息来源',
            prop: 'spare',
            search: true,
            type:'select',
            searchClearable: false,
            searchValue: '服务端请求',
            dicData: [
              {label: '服务端请求',value: '服务端请求'},
              {label: '客户端请求',value: '客户端请求'},
            ],
            width: 100,
            searchSpan: 4,
          },
          {
            label: '状态',
            prop: 'status',
            width: 80,
            type: 'select',
            search: true,
            searchSpan: 4,
            dicData: [
              { label: '已接收', value: 0 },
              { label: '已发送', value: 1 },
              { label: '发送失败', value: 2 },
              { label: '已应答', value: 3 },
              { label: '应答失败', value: 4 },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkmessage_add, false),
        viewBtn: this.vaildData(this.permission.parkmessage_view, false),
        delBtn: this.vaildData(this.permission.parkmessage_delete, false),
        editBtn: this.vaildData(this.permission.parkmessage_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      if (data.data.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
      }
      this.onLoad();
    });
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if(this.vdui.isEmpty(this.query.spare)){
        this.query.spare = '服务端请求';
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
